(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ob-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ob-navigation')){
  customElements.define('ob-navigation',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const opts={signal:this.controller.signal};
      const groups=[...this.querySelectorAll('.ob-nav__item')];
      const close=(except)=>groups.forEach(d=>{if(d!==except)d.open=false});
      groups.forEach(d=>{
        d.addEventListener('toggle',()=>{d.querySelector('summary').setAttribute('aria-expanded',String(d.open));if(d.open)close(d)},opts);
        d.querySelector('summary').setAttribute('aria-expanded',String(d.open));
      });
      document.addEventListener('click',e=>{if(!this.contains(e.target))close()},opts);
      this.addEventListener('keydown',e=>{if(e.key==='Escape'){const d=e.target.closest('.ob-nav__item');if(d&&d.open){e.preventDefault();d.open=false;d.querySelector('summary').focus()}}},opts);
      this.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))close()},opts);
      window.addEventListener('resize',()=>{if(window.innerWidth<1024)close()},opts);
      const forms=this.querySelectorAll('form');
      forms.forEach(form=>{if(form.querySelector('[role=alert],[role=status]')){const d=form.closest('details');if(d)d.open=true}});
    }
    disconnectedCallback(){this.controller?.abort()}
  });
}
if(!customElements.get('ob-mobile-navigation')){
  customElements.define('ob-mobile-navigation',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{
        if(d.open){
          const parent=d.parentElement;
          const siblings=parent.tagName==='LI'?[...parent.parentElement.children].map(li=>li.querySelector(':scope > details')):[...parent.children].filter(el=>el.tagName==='DETAILS');
          siblings.forEach(other=>{if(other&&other!==d)other.open=false});
        }
      },{signal:this.controller.signal}));
    }
    disconnectedCallback(){this.controller?.abort()}
  });
}
  } catch(e) { console.error(e); }
})();

})();
